var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 0)?_c('EmptyStateSimple',{attrs:{"captions":_vm.captions,"icon":_vm.icon},on:{"new":function($event){return _vm.$emit('new')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }